<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [showHeader]="false"
  [style]="{ width: '350px' }"
  appendTo="body"
  (onHide)="onClose()"
>
  <ng-template pTemplate="content">
    <div class="flex flex-column align-items-center my-3">
      <i class="pi pi-envelope text-4xl mb-3 text-primary"></i>
      <div class="text-900 text-xl font-medium mb-2 text-center">
        Password Reset
      </div>
      <div class="text-600 text-center mb-3">
        Send a password reset email to your address?<br />
        If you don't see the email, check your spam or junk folder.
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex gap-2 w-full">
      <button
        pButton
        pRipple
        label="Cancel"
        class="w-full p-button-secondary"
        (click)="onCancel()"
      ></button>
      <button
        pButton
        pRipple
        label="Confirm"
        class="w-full"
        (click)="onConfirm()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
